import { cn } from "@/libs/utils";
import { IconBaseType } from "@/v2-components/core/icon/type";

export default function ArrowInsertIcon({ className }: IconBaseType) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
    >
      <mask
        id="mask0_15581_97416"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_15581_97416)">
        <path
          d="M7.85596 7.80375V16C7.85596 16.2125 7.78404 16.3906 7.64021 16.5343C7.49637 16.6781 7.31821 16.75 7.10571 16.75C6.89304 16.75 6.71496 16.6781 6.57146 16.5343C6.42779 16.3906 6.35596 16.2125 6.35596 16V6.15375C6.35596 5.89775 6.44262 5.68308 6.61596 5.50975C6.78912 5.33658 7.00379 5.25 7.25996 5.25H17.106C17.3185 5.25 17.4966 5.32192 17.6405 5.46575C17.7841 5.60958 17.856 5.78775 17.856 6.00025C17.856 6.21292 17.7841 6.391 17.6405 6.5345C17.4966 6.67817 17.3185 6.75 17.106 6.75H8.90971L18.233 16.0828C18.3713 16.2213 18.4389 16.3953 18.4357 16.6048C18.4325 16.8144 18.3617 16.9885 18.2232 17.127C18.0849 17.2653 17.9125 17.3345 17.706 17.3345C17.4996 17.3345 17.3272 17.2653 17.1887 17.127L7.85596 7.80375Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
